import { render, staticRenderFns } from "./WhatsAppTemplates.vue?vue&type=template&id=2fe383de&scoped=true"
import script from "./WhatsAppTemplates.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplates.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppTemplates.vue?vue&type=style&index=0&id=2fe383de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe383de",
  null
  
)

export default component.exports